<template>
  <div class="container" style="min-height: 55vh">
    <div class="row my-4">
      <div class="col-md-12 text-center">
        <h2>{{ message }} !</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "PageNotFound",
  data() {
    return { message: "" };
  },
  mounted: function () {
    if (this.$route.query.message) {
      this.message = this.$route.query.message;
    } else {
      this.message = this.$t("message.pageNotFound");
    }
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
  },
};
</script>
